angular
    .module('annexaApp')
        .controller('TaxBlockController',['$scope', '$rootScope', 'AnnexaFormlyFactory', 'AnnexaModalFactory', 'CommonAdminModals', 'HeaderService', '$state', 'TableFilter', 'DTColumnBuilder', '$filter', 'RestService', 'Language', 'HelperService', 'ErrorFactory','AdminFactory', 'DialogsFactory', 'GlobalDataFactory', 'TramNewFactory', 'CustomFieldFactory', '$q', '$http',
            function($scope, $rootScope, AnnexaFormlyFactory, AnnexaModalFactory, CommonAdminModals, HeaderService, $state, TableFilter, DTColumnBuilder, $filter, RestService, Language, HelperService, ErrorFactory, AdminFactory, DialogsFactory, GlobalDataFactory, TramNewFactory, CustomFieldFactory, $q, $http) {
                $scope.showLoadingdiv = false;
                $scope.languageColumn = Language.getActiveColumn();
                $scope.tfilter = new TableFilter();
                $scope.tfilter.addElement($scope.languageColumn, 'text', 1, 'global.literals.name');
                
                var frequencyRender = function(data, type, object, meta) {
    				if(data){
    					return $filter('translate')('global.taxBlock.'+data);
    				}
                    return "";
                };

                $scope.filter = [
                	{ id: Language.getActiveColumn(), type: 'text', order: 1, label: 'global.literals.name' },
                	{ id: 'code', type: 'text', order: 2, label: 'global.literals.code'},
    				{ id: 'frequency', type: 'select', order: 3, label: 'global.taxBlock.frequency', dataType: 'LOCAL', data: new SortedArray(GlobalDataFactory.taxBlockFrequencies, 'name').sort(), addAll: true, nameProperty: 'name'}
                ]
                $scope.additionalColumns = [
                	{ id: 'code', title: $filter('translate')('global.literals.code'), sortable: true},
                	{ id: 'frequency', title: $filter('translate')('global.taxBlock.frequency'), render: frequencyRender, sortable: true }
                ]
                
                $scope.newTaxBlock = angular.copy(CommonAdminModals.taxBlockNew);
                
                $scope.newElement = function () {
                    var modal = undefined;
                    modal = angular.copy($scope.newTaxBlock);
                    modal.title = 'global.taxBlock.titleNew';
                    modal.annexaFormly.model = {};
                    modal.annexaFormly.model.modal_body = {};
                    modal.annexaFormly.options = {};
                    AnnexaFormlyFactory.showModal('modalNewTaxBlock', modal, $scope.saveTaxBlock, false);
                };
                
                $scope.saveTaxBlock = function(){
        	 		if (this.annexaFormly.form.$valid) {
                    	var self = this;
                    	var data = this.annexaFormly.model.modal_body;
                    	var sendData = {
                    		code:((data && data.code)?data.code:undefined),
                    		frequency:((data && data.frequency)?data.frequency:undefined),
                    		language1:((data && data.language1)?data.language1:'NotTranslated'),
                			language2:((data && data.language2)?data.language2:'NotTranslated'),
                			language3:((data && data.language3)?data.language3:'NotTranslated')
                    	}
                    	if(!sendData.frequency){
                    		self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.taxBlock.frequencyRequired') });
                    	}else if(!sendData.code){
                    		self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.taxBlock.codeRequired') });
    	                }else{
	                        RestService.insert('./api/tram/tax_block', sendData).then(function (dataGet) {
	                        	$rootScope.$broadcast('annexaAdminBaseReloadTable');
	                        	self.close();
	                        }).catch(function (error) {
	                        	self.alerts.length = 0;
	                        	if(error && error.data && error.data.message === 'The code already exists'){
	                        		self.alerts.push({ msg: $filter('translate')('global.errors.existCode') });
	                        	}else{
	                        		self.alerts.push({ msg: $filter('translate')('global.errors.unknownNew') });
	                        	}
	                        });
                    	}
                    }
                };
                
                $scope.viewElement = function (id) {
                    if(id) {
                    	var promises = [];
                        promises.push(RestService.findOne('TaxBlock', id));
                        
                        $q.all(promises).then(function(data) {
                        	var modal = angular.copy(CommonAdminModals.taxBlockEdit);
                            modal.alerts = [];
                            modal.data = JSOG.decode(data[0].data);
							modal.frequencyName = 'name';
							modal.frequencies = GlobalDataFactory.taxBlockFrequencies;
							modal.languageColumn = Language.getActiveColumn();
							modal.updateTaxBlock = $scope.updateTaxBlock;
							modal.printFrequency = function(model){
								if(model) {
									if(model.id){
										return $filter('translate')('global.taxBlock.'+model.id);
									}else{
										return $filter('translate')('global.taxBlock.'+model);
									}
				                } else {
				                    return "";
				                }
							}
                            $scope.modelTaxTemplate = modal;
							AnnexaModalFactory.showModal('modaTaxBlockEdit', modal);
                        });
                    }
                };
        	   
                $scope.updateTaxBlock = function(val, prop) {
            		var self = this;
                	var data = this.data;
                	var sendData = angular.copy(data);
                	var isValid = true;
                	if(prop === 'code'){
                		if(!val){
                    		self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.taxBlock.frequencyRequired') });
                    		isValid = false;
                		}else{
                			sendData.code = val;
                		}
                	}else if(prop === 'frequency'){
                		if(val && val.id){
                			sendData.frequency = val.id;
                		}else{
                			if(!val){
                				self.alerts.length = 0;
                        		self.alerts.push({ msg: $filter('translate')('global.taxBlock.codeRequired') });
                        		isValid = false;
                			}else{
                				sendData.frequency = val;
                			}
                		}
                	}
                	if(isValid){
	                	RestService.update('./api/tram/tax_block/' + sendData.id, sendData).then(function() {
	                        $rootScope.$broadcast('annexaAdminBaseReloadTable');
	                    }).catch(function (error) {
	                    	self.alerts.length = 0;
	                    	if(error && error.data && error.data.message === 'The code already exists'){
                        		self.alerts.push({ msg: $filter('translate')('global.errors.existCode') });
                        	}else{
                        		self.alerts.push({ msg: $filter('translate')('global.errors.unknownUpdate') });
                        	}
	                    });
                	}
                };
    }]);